module.exports = __webpack_public_path__ + "img/1.8ed16c1b.png";